import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
    infoIcon: {
        "& svg": {
            margin: '0'
        }
    }
}))